module.exports = __webpack_public_path__ + "static/media/valeria-lopes.27ae5ed0.webp";